module.exports = __webpack_public_path__ + "media/images/landing/persons/josef-matejka-0e42870398582170bfc6228420fe194f.jpeg";